import { FC } from 'react'

import { Cluster, Grid, Skeleton, Stack } from '@forto-dev/phoenix-ui-core'
import { Quote } from '@forto-dev/phoenix-ui-core/ship'

export const QuotesMainSkeleton: FC = () => {
  return (
    <Stack gap={24}>
      <Grid col={12} gap={16}>
        <Skeleton variant="button" fullWidth />
        <Skeleton variant="button" fullWidth />
        <Skeleton variant="button" fullWidth />
        <Skeleton variant="button" fullWidth />
      </Grid>
      <Stack>
        {Array.from({ length: 2 }).map((_, index) => (
          <Quote
            key={index}
            details={
              <Stack gap={4}>
                <Cluster y="center" gap={8}>
                  <Skeleton variant="avatar" />
                  <Skeleton />
                </Cluster>
                <Skeleton variant="content" fullWidth />
              </Stack>
            }
            reference={
              <Stack gap={4}>
                <Skeleton />
                <Skeleton variant="content" fullWidth />
              </Stack>
            }
            status={<Skeleton variant="button" />}
            timeline={
              <Stack gap={8}>
                <Skeleton />
                <Grid col={2}>
                  <Skeleton variant="content" fullWidth />
                </Grid>
              </Stack>
            }
            actions={
              <Cluster gap={8}>
                <Skeleton variant="button" />
                <Skeleton variant="icon" />
              </Cluster>
            }
          />
        ))}
      </Stack>
    </Stack>
  )
}
